import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import type { GetCurrentStorageUsageQuery as GetCurrentStorageUsageQueryType } from './__types__/GetCurrentStorageUsageQuery.ts';
import { GetCurrentStorageUsageQuery } from './GetCurrentStorageUsage.graphql.ts';

export const preloadStorageEnforcementBanner = () =>
	query<GetCurrentStorageUsageQueryType, {}>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: GetCurrentStorageUsageQuery,
	});
